<template>
<Header :style="{position: 'fixed', width: '100%'}">
  <div class="container">
    <div class="navbar-brand" style="text-align:center;">
      <router-link :to="'/'+$router.currentRoute.params.shortLink+'/landing'">
        <img :src="logoUrl" alt="logo" v-if="pageSettings.logoUrl" />
      </router-link>
			
			<Button @click="logoutClick()" v-if="hasReg">Logout</Button>
    </div>
  </div>
</Header>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'

export default {
	data () {
		return {

		}
	},

	computed: {
		...mapGetters('registrations', {
			registration: 'getCopy',
		}),
		...mapGetters('page-settings', {
			getPageSettings: 'find'
		}),
		
		hasReg(){
			return this.registration?true:false;
		},

		pageSettings () {
			return this.getPageSettings({query:{}}).data[0]
		},

		logoUrl () {
			let pageSettings = this.pageSettings
			return (pageSettings && pageSettings.logoUrl) ? pageSettings.logoUrl : ''
		}
	},
	methods:{
		...mapGetters('webcast', {
			webcast: 'getCopy'
		}),
		...mapActions('registrations', {
      logout: 'logout'
		}),
		logoutClick(){
			this.logout(this.webcast()._id);
			this.$router.push('landing');
		}
	}
}
</script>

<style>
	
</style>
